/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { SapHanaInstance } from '../models/SapHanaInstance';

/**
* Properties of an Azure SAP HANA VM resource. Present only when `resourceType` is set to `AZURE_SAP_HANA_VM`. 
*/
export class AzureSapHanaResource {
  /**
  * List of SAP HANA instances on this VM.
  */
  'instances'?: Array<SapHanaInstance>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "instances",
      "baseName": "instances",
      "type": "Array<SapHanaInstance>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AzureSapHanaResource.attributeTypeMap;
  }

  public constructor() {
  }
}

